var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"col-12 alert alert-secondary text-center"},[_c('span',[_vm._v(_vm._s(_vm.listLength + " " + _vm.countResult + " " + (_vm.listLength > 1 || _vm.listLength == 0 ? _vm.meetPlural : _vm.meetSingular) + " " + _vm.selectionCriteria + ". " + _vm.alternatives))])])
}
var staticRenderFns = []

export { render, staticRenderFns }